export default __webpack_public_path__ + "static/media/single_web-sm@1x.26cd905d.jpg";